import { render, staticRenderFns } from "./CarrierLabel.vue?vue&type=template&id=a7845368&scoped=true&"
import script from "./CarrierLabel.vue?vue&type=script&lang=js&"
export * from "./CarrierLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7845368",
  null
  
)

export default component.exports